import moment from "moment";
import jsPDF from "jspdf";
import { ENVIRONMENT_CONSTANT } from "../constants/env.constant";
import { dateTimeFormat } from "./date-format";
import {COLORS} from "../constants/constant";

export const getTimeFilterValue = (value, customDate) => {
    let startDate = new Date();
    let endDate = new Date();
    switch (value) {
        case 'today':
          startDate = new Date();
          startDate.setHours(0, 0, 0, 0);
          endDate = new Date();
          endDate.setHours(23, 59, 59, 999);
          break;
        case 'yesterday':
          startDate = new Date();
          startDate.setDate(startDate.getDate() - 1);
          startDate.setHours(0, 0, 0, 0);
          endDate = new Date();
          endDate.setDate(endDate.getDate() - 1);
          endDate.setHours(23, 59, 59, 999);
          break;
        case 'last_7_days':
          startDate = new Date();
          startDate.setDate(startDate.getDate() - 6);
          startDate.setHours(0, 0, 0, 0);
          endDate = new Date();
          endDate.setHours(23, 59, 59, 999);
          break;
        case 'last_30_days':
          startDate = new Date();
          startDate.setDate(startDate.getDate() - 29);
          startDate.setHours(0, 0, 0, 0);
          endDate = new Date();
          endDate.setHours(23, 59, 59, 999);
          break;
        case 'this_month':
          startDate = new Date();
          startDate.setDate(1);
          startDate.setHours(0, 0, 0, 0);
          endDate = new Date();
          endDate.setMonth(endDate.getMonth() + 1, 0);
          endDate.setHours(23, 59, 59, 999);
          break;
        case 'last_month':
          startDate = new Date();
          startDate.setMonth(startDate.getMonth() - 1, 1);
          startDate.setHours(0, 0, 0, 0);
          endDate = new Date();
          endDate.setDate(0);
          endDate.setHours(23, 59, 59, 999);
          break;
        case 'this_year':
          startDate = new Date();
          startDate.setMonth(0, 1);
          startDate.setHours(0, 0, 0, 0);
          endDate = new Date();
          endDate.setMonth(11, 31);
          endDate.setHours(23, 59, 59, 999);
          break;
        case 'last_year':
          startDate = new Date();
          startDate.setFullYear(startDate.getFullYear() - 1, 0, 1);
          startDate.setHours(0, 0, 0, 0);
          endDate = new Date();
          endDate.setFullYear(endDate.getFullYear() - 1, 11, 31);
          endDate.setHours(23, 59, 59, 999);
          break;
        default:
          startDate = moment(customDate?.from).toDate();
          startDate.setHours(0, 0, 0, 0);
          endDate = moment(customDate?.to).toDate();
          endDate.setHours(23, 59, 59, 999);
          // throw new Error('Invalid date range');
      }
      
      return {
        startDate: dateTimeFormat(startDate, true),
        endDate: dateTimeFormat(endDate, true)
       }
}

export const downloadBlob = (blob, name) => {
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([blob]));
    const fileName = `${name ? name : 'donation_records_'}${moment().format('YYYY-MM-DD')}.csv`;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

}

export const getImageUrl = (imageName) => {
  const imageUrl = ENVIRONMENT_CONSTANT.CAMPAIGN_ICON_URL+(imageName?.includes('carpeting') ? imageName.replace('.jpg.jpg','.jpg') : imageName);
  return imageUrl;
}

export const getTextColorByBG = (backgroundColor) => {
  if(backgroundColor){
    var color = (backgroundColor?.charAt(0) === '#') ? backgroundColor.substring(1, 7) : backgroundColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) ?
        'black' : 'white';
  }else{
    return "";
  }

}

export const activeTilesBasedOnDate = (tile) => {
  const today = new Date();
  const start = new Date(tile.active_from);
  const end = new Date(tile.active_to);

  return today.getTime() >= start.getTime() && today.getTime() <= end.getTime();
}

//download a svg as image 
export const downloadSVGAsImage = (id, name, format = 'png') => {
  const canvas = document.getElementById(id);

  if(format === 'pdf'){
    const img = canvas.toDataURL(`image/png`);
    const pdf = new jsPDF({
    orientation: "portrait",
    unit: "pt",
    format: [canvas.width, canvas.height],
  });
    pdf.addImage(img, "PNG", 0, 0, canvas.width, canvas.height);
    pdf.save(`${name}.pdf`);
  }
  else{
    // Create an image element
    const img = new Image();
    img.src = canvas.toDataURL(`image/${format}`);

    // Create a download link
    const a = document.createElement("a");
    a.href = img.src;
    a.download = `${name}.${format}`;
    a.click();
  }

  
};

//inserting text at cursor
export const insertTextAtCursor = (text, textareaRef) => {
  const textarea = textareaRef.current;
  const startPosition = textarea.selectionStart;
  const endPosition = textarea.selectionEnd;

  const currentValue = textarea.value;

  // Count the number of characters up to the selection start position
  const characterCount = Array.from(currentValue.slice(0, startPosition)).length;

  const newValue =
      currentValue.slice(0, startPosition) +
      text +
      currentValue.slice(endPosition);

  textarea.value = newValue;
  // setValue('email_subject', newValue);
  // Calculate the new selection start position based on the character count
  const newStart = characterCount + text.length;

  // Calculate the new selection end position
  const newEnd = newStart;

  textarea.selectionStart = newStart;
  textarea.selectionEnd = newEnd;
  return newValue;
};

export const renderFieldValue = (value, type) => {
  if (!value) return <span className="text-muted">-</span>;

  if (type === "date") return moment(value).format("LL");
  if (type === "boolean") return value ? "Yes" : "No";
  if (Array.isArray(value)) return value.join(", ");

  return value;
};

// donor tag related utils start
export const getTagStyle = (bg) => {
  const found = COLORS.find((c) => c.bg === bg);

  return found
    ? { color: found.color, border: found.border }
    : { color: "#5f5e5a", border: "#b4b2a9" };
};

export const getRandomColor = () => {
  const random = COLORS[Math.floor(Math.random() * COLORS.length)];
  return random.bg;
};

// get next tag order
export const getMaxOrder = (tags) => {
  if (!tags?.length) {
    return 0;
  }

  return Math.max(
    ...tags.map((tag) => Number(tag.tag_order) || 0)
  );
};

// Check if two tag arrays are equal 
export const areTagsEqual = (prevTags = [], nextTags = []) => {
  if (prevTags.length !== nextTags.length) return false;

  return prevTags.every((tag, index) => {
    const nextTag = nextTags[index];  
    return (
      tag.id === nextTag?.id &&
      tag.title === nextTag?.title 
    );
  });
};
// donor tag related utils end
//convert a #rrggbb hex to an rgba() string with the given alpha
export const hexToRgba = (hex, alpha = 1) => {
  const h = (hex || '').replace('#', '');
  if (h.length !== 6) return hex;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

//preset theme colors offered to admins for the fundraising Spotlight display
export const SPOTLIGHT_PRESET_COLORS = ['#155C4E', '#0047AB', '#1A6B4A', '#7C3AED', '#DC2626', '#D97706', '#0D9488'];

//backend anonymity flag can arrive as 1 / '1' / true / 'true' — treat all as anonymous
export const isAnonymousDonation = (value) => value === 1 || value === '1' || value === true || value === 'true';

//donor display name for public fundraising screens: "First L." when both names exist,
//otherwise whichever single name is present, else "Anonymous"
export const getDonorDisplayName = (item) => {
  if (isAnonymousDonation(item?.is_anonymous)) return 'Anonymous';
  const first = item?.first_name?.trim();
  const last = item?.last_name?.trim();
  if (first && last) return `${first} ${last.charAt(0)}.`;
  if (first) return first;
  if (last) return last;
  return 'Anonymous';
};
